<template>
  <v-container
    tag="section"
  >
    <v-col
      cols="12"
    >
      <base-material-card
        color="coolrunner"
        icon="mdi-account"
        inline
        class="px-5 py-3"
      >
        <template v-slot:after-heading>
          <div class="text-h2 font-weight-light">
            {{ entity.name }}
          </div>
        </template>
        <v-form>
          <v-container class="py-0">
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="entity.name"
                :label="$t('name')"
              />
            </v-col>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="entity.email"
                :label="$t('email')"
              />
            </v-col>
            <v-col>
              <v-select
                v-model="entity.role"
                :items="roles"
                item-text="title"
                item-value="val"
              />
            </v-col>
            <v-row>
              <v-checkbox
                v-model="entity.active"
                :label="$t('active')"
                class="mt-5 ml-3"
              />
              <v-btn
                class="ml-auto mt-5"
                right
                color="green"
                @click="save"
              >
                <v-icon class="mr-3">
                  mdi-content-save
                </v-icon>
                {{ $t('save') }}
              </v-btn>
            </v-row>
          </v-container>
        </v-form>
      </base-material-card>

      <base-material-card
        v-if="showPasswordUpdate"
        color="coolrunner"
        icon="mdi-lock"
        inline
        class="px-5 py-3"
      >
        <template v-slot:after-heading>
          <div class="text-h2 font-weight-light">
            {{ $t('update_password') }}
          </div>
        </template>
        <v-container class="py-0">
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="password"
              type="password"
              :label="$t('password')"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="password_confirm"
              type="password"
              :label="$t('confirm') + ' ' + $t('password')"
            />
          </v-col>

          <v-row>
            <v-btn
              class="ml-auto mt-5"
              right
              :disabled="passwordButtonDisabled"
              color="green"
              @click="updatePassword"
            >
              <v-icon class="mr-3">
                mdi-content-save
              </v-icon>
              {{ $t('save') }}
            </v-btn>
          </v-row>
        </v-container>
      </base-material-card>
    </v-col>
    <base-loading-overlay :loading="loading" />
  </v-container>
</template>
<script>

  import Edit from '@/mixins/Edit'
  import { ROLES, SUPERUSER, ADMIN, ALL } from '../../../utils/constants'
  export default {

    mixins: [Edit],
    data () {
      return {
        endpoint: 'users',
        name: 'user',
        crudl: {
          C: SUPERUSER.val,
          R: ALL.val,
          U: SUPERUSER.val,
          D: SUPERUSER.val,
          L: ALL.val,
        },
        password: '',
        password_confirm: '',
      }
    },
    computed: {
      roles: function () {
        return ROLES
      },
      passwordButtonDisabled: function () {
        return !this.password || this.password !== this.password_confirm
      },
      showPasswordUpdate: function () {
        return this.$getUser().id === this.entity.id || this.$getUser().role >= SUPERUSER.val
      },
    },
    methods: {
      updatePassword: function () {
        this.loading = true
        this.$put(`/${this.endpoint}/${this.entity.id}/updatePassword`, { password: this.password, password_confirm: this.password_confirm })
          .then(response => {
            this.$toast(`${this.$t('password')} ${this.$t('saved_correctly')}`)

            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      },
    },
  }
</script>
